import React from 'react'

const PlusIcon = ({ color = '#BE9137', disabled }) => {
  return (
    <svg
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity={disabled ? '0.5' : '1'}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47Z"
        fill={color}
      />
      <path
        d="M21.7734 24.7813H16.5171V21.8068H21.7734V16.5098H24.7479V21.8068H30.0042V24.7813H24.7479V30.0105H21.7734V24.7813Z"
        fill="white"
      />
    </svg>
  )
}

export default PlusIcon
